import { Typography } from "@circle-react-shared/uikit/Typography";

import { Icon } from "@/react/components/shared/Icon";
import { classNames } from "@/react/helpers/twMergeWithCN";

interface PlanFeatureProps {
  color?: string;
  feature: string;
  fontWeight?: string;
  highlightColor?: string;
  highlightIcon?: string;
  isHighlighted: boolean;
  isOnOffer: boolean;
  LabelComponent?: React.ElementType;
}

export const PlanFeature = ({
  feature,
  fontWeight = "normal",
  isHighlighted,
  isOnOffer = false,
  color = "text-slate-700 dark:text-slate-300",
  highlightColor = "text-blue-highlight",
  highlightIcon,
  LabelComponent = Typography.BodySm,
}: PlanFeatureProps) => {
  const iconType = isHighlighted ? highlightIcon || "16-star-fill" : "check";

  return (
    <div key={feature} className="flex flex-row items-center gap-1">
      {isHighlighted ? (
        <Icon
          type={iconType}
          size={16}
          className={classNames(
            "mr-1",
            isHighlighted ? highlightColor : "",
            isOnOffer ? "text-[#493B73]" : "",
          )}
          useWithFillCurrentColor
          useWithStrokeCurrentColor
        />
      ) : (
        <Icon
          type={iconType}
          size={16}
          useWithFillCurrentColor
          useWithStrokeCurrentColor
          className="text-green-success mr-1"
        />
      )}
      <LabelComponent color={color} key={feature} weight={fontWeight}>
        {feature}
      </LabelComponent>
    </div>
  );
};
